import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=b2c31c76&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=b2c31c76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c31c76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2c31c76')) {
      api.createRecord('b2c31c76', component.options)
    } else {
      api.reload('b2c31c76', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=b2c31c76&scoped=true&", function () {
      api.rerender('b2c31c76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lxim1T9y6JHr/JS/teamMember.vue"
export default component.exports